let KeyPlayerStackingCombinations = {
    KEY_PLAYER_STACKING_COMBO_SET_EXPOSURE_MAX: 'KEY_PLAYER_STACKING_COMBO_SET_EXPOSURE_MAX',
    KEY_PLAYER_STACKING_SET_COMBINATION_GROUPS: 'KEY_PLAYER_STACKING_SET_COMBINATION_GROUPS',
};

export default KeyPlayerStackingCombinations;
